/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_Ical_HintInputs */

const cs_settings_profile_ical_hint = /** @type {(inputs: Settings_Profile_Ical_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidejte tuto URL do Google / Outlook jako odběr kalendáře.`)
};

const en_settings_profile_ical_hint = /** @type {(inputs: Settings_Profile_Ical_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add this URL to Google / Outlook as a calendar subscription.`)
};

/**
* | output |
* | --- |
* | "Add this URL to Google / Outlook as a calendar subscription." |
*
* @param {Settings_Profile_Ical_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_ical_hint = /** @type {((inputs?: Settings_Profile_Ical_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_Ical_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_ical_hint(inputs)
	return cs_settings_profile_ical_hint(inputs)
});